<plotly-plot
  [data]="plotlyData()"
  [layout]="plotlyLayout()"
  [config]="plotlyConfig()"
  class="plot"
></plotly-plot>
